'use strict';

function needsCanonicalProgress(progress) {
  const omissions = progress?.canonicalPayloadOmissions;
  return (
    Number(omissions?.resultsOmitted) > 0 ||
    Number(omissions?.processesWithUnavailableResults) > 0
  );
}

function shouldLoadCanonicalProgress(progress) {
  // The canonical SHA can change on every live poll as status changes. Keep
  // rendering the inline processes until the collector finalizes the archive.
  return (
    needsCanonicalProgress(progress) &&
    progress?.collectorStatus !== 'collecting'
  );
}

async function decodeCanonicalProgress(progress, bytes) {
  const descriptor = progress?.canonicalPayloadArtifact;
  if (
    !descriptor ||
    typeof descriptor.sha256 !== 'string' ||
    !/^[0-9a-f]{64}$/i.test(descriptor.sha256) ||
    !(bytes instanceof ArrayBuffer) ||
    bytes.byteLength !== Number(descriptor.bytes)
  ) {
    throw new Error('Archived results do not match this task.');
  }

  const digest = await crypto.subtle.digest('SHA-256', bytes);
  const sha256 = Array.from(new Uint8Array(digest), (byte) =>
    byte.toString(16).padStart(2, '0')
  ).join('');
  if (sha256 !== descriptor.sha256.toLowerCase()) {
    throw new Error('Archived results do not match this task.');
  }

  const canonical = JSON.parse(new TextDecoder().decode(bytes));
  if (
    !canonical ||
    !Array.isArray(canonical.processes) ||
    (descriptor.executionFingerprint &&
      canonical.executionFingerprint !== descriptor.executionFingerprint)
  ) {
    throw new Error('Archived results are incomplete.');
  }

  const resultsTotal = canonical.processes.reduce((total, process) => {
    if (!process || !Array.isArray(process.results)) {
      throw new Error('Archived results are incomplete.');
    }
    return total + process.results.length;
  }, 0);
  if (
    resultsTotal !== Number(descriptor.resultsTotal) ||
    canonical.processes.length !== Number(descriptor.processesTotal)
  ) {
    throw new Error('Archived result counts do not match this task.');
  }
  return canonical.processes;
}

module.exports = {
  needsCanonicalProgress,
  shouldLoadCanonicalProgress,
  decodeCanonicalProgress,
};
